import * as $ from "jquery";

export default {
    /**
     * validate recaptcha
     * @param recaptchaId
     * @param errorMassageElement
     */
    validate(recaptchaId, errorMassageElement) {
        let optWidgetId = Number($(recaptchaId).find('iframe').index("div[data-sitekey] iframe"));
        let response = grecaptcha.getResponse(optWidgetId);

        if (response.length == 0) {
            $(errorMassageElement).text($.validator.messages.reCaptcha).addClass("invalid-feedback").show();
            if (!$(recaptchaId).hasClass("error")) {
                $(recaptchaId).addClass("error");
            }
            return false;
        } else {
            $(errorMassageElement).text('');
            $(recaptchaId).removeClass("error");
            return true
        }
    },

    /**
     * validate value recaptcha
     * @param recaptchaId
     * @param errorMassageElement
     */
    validateByValue(recaptchaId, errorMassageElement) {
        let response = String($(recaptchaId).val());

        if (response.length == 0) {
            $(errorMassageElement).text($.validator.messages.reCaptcha).addClass("invalid-feedback").show();
            if (!$(recaptchaId).hasClass("error")) {
                $(recaptchaId).addClass("error");
            }
        } else {
            $(errorMassageElement).text('');
            $(recaptchaId).removeClass("error");
        }

        return response;
    }
}import * as $ from "jquery";

export default {
    /**
     * validate recaptcha
     * @param recaptchaId
     * @param errorMassageElement
     */
    validate(recaptchaId, errorMassageElement) {
        let optWidgetId = Number($(recaptchaId).find('iframe').index("div[data-sitekey] iframe"));
        let response = grecaptcha.getResponse(optWidgetId);

        if (response.length == 0) {
            $(errorMassageElement).text($.validator.messages.reCaptcha).addClass("invalid-feedback").show();
            if (!$(recaptchaId).hasClass("error")) {
                $(recaptchaId).addClass("error");
            }
            return false;
        } else {
            $(errorMassageElement).text('');
            $(recaptchaId).removeClass("error");
            return true
        }
    },

    /**
     * validate value recaptcha
     * @param recaptchaId
     * @param errorMassageElement
     */
    validateByValue(recaptchaId, errorMassageElement) {
        let response = String($(recaptchaId).val());

        if (response.length == 0) {
            $(errorMassageElement).text($.validator.messages.reCaptcha).addClass("invalid-feedback").show();
            if (!$(recaptchaId).hasClass("error")) {
                $(recaptchaId).addClass("error");
            }
        } else {
            $(errorMassageElement).text('');
            $(recaptchaId).removeClass("error");
        }

        return response;
    }
}